import { useState, useEffect } from 'react'
import { navigate } from 'gatsby'
import UserSessionStorage from './userSessionStorage'


const UseValidateView = (redirect) => {
  const [isSession, setIsSession] = useState(false)
  const session = new UserSessionStorage()


  const handleRedirectTO = () => {
    sessionStorage.setItem('redirectTo', redirect)
    navigate('/inicio-de-sesion')
  }

  useEffect(() => {
    if (!session.getToken()) {
      setIsSession(false)
      if (redirect) handleRedirectTO()
    } else {
      setIsSession(true)
    }


  }, [])


  return [
    isSession,
  ]

}

export default UseValidateView
